<template>
  <div>
    <add-address @submitCallback="submitCallback"></add-address>
  </div>
</template>

<script>
import addAddress from '@/common/components/addressPopup/addAddress.vue'
export default {
  name: 'addAddress',
  components: {
    'add-address': addAddress
  },
  data() {
    return {
      recordId: '',
      otmsOrderNum: '',
      addressId: ''
    }
  },
  created() {
    this.recordId = this.$route.query.recordId
  },
  methods: {
    async submitCallback({ addrId = '' }) {
      console.log('submitCallback')
      const that = this
      that.addressId = addrId
      const res = await that.$api.bindAddress({
        sGroupId: this.$config.sGroupId,
        addressId: addrId,
        recordId: this.recordId
      })
      if (res.code === 0) {
        that.otmsOrderNum = res.data.otmsOrderNUm
        await that.addOtmsNumber()
      } else {
        that.$toast(res.msg || '物流绑定失败')
      }
    },
    // 绑定物流单号
    async addOtmsNumber() {
      const that = this
      const { periodId } = that.$route.query
      const res = await that.$api.addOtmsNumber({
        period_id: periodId,
        otms_order_num: that.otmsOrderNum,
        address_id: that.addressId
      })
      if (res.code === 0) {
        that.$router.go(-1)
      } else {
        that.$toast(res.msg || '绑定物流单号失败')
      }
    }
  }
}
</script>
<style lang="less">
.xes-login-title i {
  display: none;
}
</style>
